import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { calculateTotalRow, checkForTotalColumn, tableColumns } from "./data";
import { datatypes, deleteTableColumn } from "data/globalData";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { GlobalState } from "context/GlobalContext";
import { getColDefaultValue } from "components/PimDashboard/data";
import Button from "@mui/material/Button";
import { AddRounded, EditRounded } from "@mui/icons-material";
import { DisabledBox, TotalBox, WhiteBgBox } from "../data";
import { roundDecimalValueUptoTwoDigit } from "utils/RoundDecimalValue";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { AuthState } from "context/AuthContext";
const colStyle = {
	headerAlign: "center",
	align: "center",
	minWidth: 133,
	flex: 1,
};

const PackingTrimsTable = ({
	rows,
	setRows,
	totalRow,
	setTotalRow,
	mode = "" || "create" || "edit",
	editMode = false,
	setEditMode = () => {},
	handleSave = () => [],
}) => {
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();
	const { user } = AuthState();

	const defTableColumns = [
		{
			...tableColumns.trims_id,
			...colStyle,

			headerName: tableColumns.trims_id.name,
			field: tableColumns.trims_id.key,
			editable: true,
			colSpan: (value, row) => {
				if (checkForTotalColumn(row)) {
					return 5;
				}
				return undefined;
			},
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...tableColumns.category,
			editable: true,

			valueOptions: [],
			...colStyle,
			headerName: tableColumns.category.name,
			field: tableColumns.category.key,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...tableColumns.description,
			editable: true,

			valueOptions: [],
			...colStyle,
			headerName: tableColumns.description.name,
			field: tableColumns.description.key,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...tableColumns.supplier,
			field: tableColumns.supplier.key,
			headerName: tableColumns.supplier.name,
			flex: 1,
			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...tableColumns.consumption,
			field: tableColumns.consumption.key,
			headerName: tableColumns.consumption.name,

			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		// {
		// 	...tableColumns.consumption_unit,
		// 	field: tableColumns.consumption_unit.key,
		// 	headerName: tableColumns.consumption_unit.name,
		//
		// 	editable: true,
		// 	type: "singleSelect",
		// 	valueOptions: [],
		// 	...colStyle,
		// 	renderCell: ({ field, row }) => {
		// 		return <WhiteBgBox field={field} row={row} />;
		// 	},
		// },
		{
			...tableColumns.price,
			field: tableColumns.price.key,
			headerName: tableColumns.price.name,

			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...tableColumns.value,
			field: tableColumns.value.key,
			headerName: tableColumns.value.name,

			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <DisabledBox field={field} row={row} />;
			},
		},
	];

	const [packingTrimsColumns, setPackingTrimsColumns] = useState([]);
	const [rowsCopy, setRowsCopy] = useState(rows ? [...rows] : []);
	const [deletedRowIds, setDeletedRowIds] = useState([]);

	const defaultRow = packingTrimsColumns?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});

	useEffect(() => {
		setPackingTrimsColumns([...defTableColumns]);
		setTotalRow(calculateTotalRow(rows));
	}, []);

	const handleAddRowClick = () => {
		let newRow = { ...defaultRow };
		newRow["id"] = new Date().valueOf();
		newRow["is_new"] = true;
		newRow["created_by"] = user.email;
		setRows((prev) => [...prev, newRow]);
	};
	const handleDeleteRowClick = (rowToDelete) => {
		setRows((prev) => {
			const newRows = prev.filter((row) => row.id !== rowToDelete.id);
			setDeletedRowIds((prev) => [...prev, rowToDelete.id]);
			setTotalRow(calculateTotalRow(newRows));
			return newRows;
		});
	};
	const processRowUpdate = (newRow, OldRow) => {
		let correct = true;
		packingTrimsColumns?.forEach((col) => {
			if (col.data_type === datatypes.NUMBER.key || col.data_type === datatypes.DECIMAL.key)
				if (isNaN(newRow[col.key])) correct = false;
		});
		console.log(correct, "sdmnfbnsdfmsd");
		if (correct) {
			const value = roundDecimalValueUptoTwoDigit(newRow[tableColumns.price.key] * newRow[tableColumns.consumption.key]);
			let updatedNewRow = { ...newRow, [tableColumns.value.key]: value, is_updated: true, last_updated_by: user.email };
			setRows((prev) => {
				let newRows = prev.map((row) => {
					if (row.id === updatedNewRow.id) return updatedNewRow;
					else return row;
				});
				setTotalRow(calculateTotalRow(newRows));
				return newRows;
			});
			return updatedNewRow;
		} else {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Please Enter Proper Values",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	const handleCancelEditClick = () => {
		setRows(rowsCopy);
		setDeletedRowIds([]);
		setEditMode(false);
	};
	const handleEditClick = () => {
		setEditMode(true);
	};
	const handleSaveClick = async () => {
		try {
			setLoadingOpen(true);
			const result = await handleSave(rows, deletedRowIds);
			if (result) {
				setRows(result);
				setRowsCopy(result);
				setDeletedRowIds([]);
				setEditMode(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Data Saved Successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	return (
		<Box>
			<Box display="flex" justifyContent="space-between" pt={1} pb={1}>
				<Typography variant="h6"> Packing Trims </Typography>
				<Box display="flex" columnGap="5px">
					{mode === "create" ? (
						<Button variant="contained" size="small" onClick={handleAddRowClick} startIcon={<AddRounded />}>
							Add Row
						</Button>
					) : mode === "edit" ? (
						<>
							{editMode ? (
								<>
									<Button variant="contained" size="small" onClick={handleAddRowClick} startIcon={<AddRounded />}>
										Add Row
									</Button>
									<Button variant="outlined" size="small" onClick={handleCancelEditClick}>
										Cancel Edit
									</Button>
									<Button variant="contained" size="small" onClick={handleSaveClick}>
										Save
									</Button>
								</>
							) : (
								<Button variant="contained" size="small" onClick={handleEditClick} startIcon={<EditRounded />}>
									Edit
								</Button>
							)}
						</>
					) : (
						<></>
					)}
				</Box>
			</Box>
			<DataGrid
				rows={rows ? [...rows, totalRow] : []}
				getRowId={(row) => row.id}
				columns={[
					...packingTrimsColumns,
					deleteTableColumn(handleDeleteRowClick, (row) => (mode !== "create" && !editMode) || checkForTotalColumn(row)),
				]}
				sx={{
					width: "100%",
					"& .MuiDataGrid-row": {
						cursor: "pointer",
					},
					"& .MuiDataGrid-row:hover": {
						backgroundColor: "transparent",
					},
					"& .MuiDataGrid-columnHeader": {
						cursor: "pointer",
						background: grey[400],
						textTransform: "uppercase",
					},
					"& .MuiDataGrid-cell": {
						padding: 0,
					},
				}}
				disableRowSelectionOnClick
				pagination={false} // Remove footer
				hideFooter={true}
				autoHeight
				showCellVerticalBorder
				showColumnVerticalBorder
				density="compact"
				isCellEditable={({ row }) => (mode === "create" || editMode) && !checkForTotalColumn(row)}
				processRowUpdate={processRowUpdate}
			/>
		</Box>
	);
};

export default PackingTrimsTable;
